import { TGameFunSupport } from 'js/components/system/App/store/types';

export const getActualMode = (
    { mode, isLoggedIn, funSupport }: { mode?: number; isLoggedIn: boolean; funSupport: TGameFunSupport }
) => {
    let actualMode = mode !== undefined ? mode : 1;

    // if we try to open demo mode need to check if it's available
    if (!actualMode) {
        const gameModesMap = {
            both: 0,
            unavailable: 1,
            guest: Number(isLoggedIn),
            user: Number(isLoggedIn)
        };

        actualMode = gameModesMap[funSupport];
    }

    return actualMode;
};

export const isGamingPath = (pathname: string): boolean => {
    const gameRegExp = /igaming\/(?!games-info)/g;

    return gameRegExp.test(pathname);
};
